import React from 'react';
import { Row, Columns } from 'views/Grid';
import classnames from 'classnames';

class InputWithHint extends React.Component {
  render () {
    const { children, hint, hintContainerClassName, childrenContainerClassName } = this.props;
    return (
      <Row className="medium-collapsed">
        <Columns className={childrenContainerClassName}>
          {children}
        </Columns>
        <Columns className={hintContainerClassName}>
          <div className={classnames({ 'text-hint': hint })}>{hint}</div>
        </Columns>
      </Row>
    );
  }
}

InputWithHint.defaultProps = {
  childrenContainerClassName: 'small-12 medium-6',
  hintContainerClassName: 'small-12 medium-6',
};

export default InputWithHint;



// WEBPACK FOOTER //
// ./src/common/views/form/InputWithHint.js